/**
 * ContadorFamilia - qué pasa hoy con la proteína de un alimento que se calibra.
 *
 * Jesús, 13-08-2026: «un contador en la línea del alimento desde el primer gramo». La
 * calibración progresiva es la regla más difícil de adivinar de toda la app: la proteína de
 * unas almendras no cuenta hasta que el DÍA pasa de 20 g, y hasta entonces eso ocurría sin
 * que nada lo dijera.
 *
 * DOS CAMBIOS DEL 26-08 (puntos 133 y 134), y los dos porque el cartel mentía:
 *
 *  · ANTES DEL TRAMO HAY UNA PUERTA. La proteína del alimento tiene que llegar a un tercio
 *    del macro dominante de su bloque; si no llega, no cuenta NUNCA, comas lo que comas.
 *    El cartel no la conocía y le salía a todos los frutos secos por igual: a las nueces
 *    (23 %) les decía «te cuenta entera» y aportaban 0. «Que salga sólo en los que llegan al
 *    tercio. A los demás, una sola frase y para siempre: su proteína no te cuenta.»
 *
 *  · Y AL QUE SÍ LLEGA, DECIRLE LO QUE GANA. «Te cuenta a la mitad» suena a castigo y no
 *    dice qué hacer; ahora la frase termina en lo que pasa si sigue: «con 40 g te cuenta
 *    toda». Y sale el «25 de 40 g»: el número no era la información, era el ruido.
 *
 * LO QUE NO CUENTA NO SE DICE (Francisco, 29-10: «si la proteína no se cuenta entonces no
 * se dice, como haces ahí tampoco que no cuenta hidratos»). Manda sobre la frase del 26-08:
 * fuera «Su proteína no te cuenta» y «su proteína todavía no te cuenta». Solo se dice cuando
 * cuenta a medias, y corto («de alguna manera más clara y resumida»): «Cuenta el 50 % de su
 * proteína · entera con más de 40 g». Entera tampoco se dice: la línea ya la enseña.
 *
 * Los gramos son del DÍA entero, que es lo que decide el tramo desde el 13-08. Por eso el
 * mismo alimento enseña lo mismo esté en la comida que esté.
 */
import React from 'react';

// Los tramos de la spec (17-07-2026), los mismos que aplica `calibracion_dia.py`.
const FAMILIAS = {
    fruto_seco: { tramos: [20, 40] },
    cereal_pan: { tramos: [50, 100] },
};

//: `className`: dónde va en la fila de quien lo pinta (ver `IngredientRow` en MealCard).
export const ContadorFamilia = ({ bloque, gramos, proteinaCuenta = true, proteinaCrece = true, className = '' }) => {
    const cfg = FAMILIAS[bloque];
    // Ni la que no cuenta nunca (no llega al tercio), ni la que cuenta entera desde el primer
    // gramo (los cereales y panes proteicos): no hay nada que decir.
    if (!cfg || !proteinaCuenta || !proteinaCrece || gramos == null) return null;

    const [primero, segundo] = cfg.tramos;
    const g = Math.round(gramos);
    // «CON MÁS DE 40 g», NO «CON 40 g» (ficha 54 del parte de Gonzalo, 5-09): el motor es
    // «hasta 20 g, nada; de 20 a 40, la mitad» (`calma_engine`, `<= 20 -> 0`).
    if (g <= primero || g > segundo) return null;

    return (
        // Sin `truncate`: en 390 px el corte se comía el final, que es lo que dice qué hacer.
        <div className={`mt-0.5 text-[11px] text-muted-foreground ${className}`} data-testid={`contador-${bloque}`}>
            {/* Con espacios que no parten: en 390 px la «g» se quedaba sola en otra línea. */}
            Cuenta el 50{' '}% de su proteína · entera con más de {segundo}{' '}g
        </div>
    );
};

export default ContadorFamilia;
